import gql from 'graphql-tag';

export default {
    deletePostMutation: gql`
        mutation DeletePosts($postId: String!) {
            deletePost(postID: $postId) {
                postID
            }
        }
    `,
};
